import { useContext } from "react";
import { HttpContext } from "../HttpContext";
import { Buffer } from 'buffer';

export default function useFileService() {
    const { httpClient } = useContext(HttpContext)
    const downloadFile = async (guid) => {
        const arrayBuffer = await httpClient.get(`/file/download/${guid}`, {
            responseType: 'arraybuffer'
        });
        let buffer = Buffer.from(arrayBuffer.data, 'binary').toString("base64");
        return buffer;
    }
    const base64ToFile = async (base64, fileName, mimeType) => {
        const response = await fetch(base64);
        const blob = await response.blob();
        return new File([blob], fileName, { type: mimeType });
    }

    return { downloadFile, base64ToFile }
}